const ID_CARD_ACTION_TYPES = {
  SAVE_NUMBER: 'SAVE_NUMBER',
  SAVE_ADHAAR_NUMBER: 'SAVE_ADHAAR_NUMBER',
  CONFIRM_OTP: 'CONFIRM_OTP',
  CONFIRM_ADHAAR_OTP: 'CONFIRM_ADHAAR_OTP',
  SAVE_CARD_INFO: 'SAVE_CARD_INFO',
  FETCH_CARD: 'FETCH_CARD',
  TRANSACTION_ID: 'TRANSACTION_ID',
  TOKEN: 'TOKEN',
  ID_CARD_INFO: 'ID_CARD_INFO',
  CERIFICATE: 'CERIFICATE',
  GET_CERTIFICATE: 'GET_CERTIFICATE',
  USER_INFO: 'USER_INFO',
  DOWNLOAD_IDCARD_INFO: 'DOWNLOAD_IDCARD_INFO',
  SAVE_PHR_ADDRESS: 'SAVE_PHR_ADDRESS',
  SET_CALLBACK: 'SET_CALLBACK',
  CONFIRM_OTP_AND_FETCH_INFO: 'CONFIRM_OTP_AND_FETCH_INFO',
  RESET_ID_CARD_STATE: 'RESET_ID_CARD_STATE',
};

export default ID_CARD_ACTION_TYPES;
